import ReleaseFiles from './ReleaseFiles.component';

export default ReleaseFiles;
